import { gql } from "apollo-boost";

export const GET_TEACHER_BOOKS = gql`
query currentTeacher {
    currentTeacher {
        id
        classBooks {
            id
            archived
            status
            createdAt
            completedAt
            currentBookChapter {
                id
                title
                statusToText
            }
            bookable {
                ... on StudentsClass {
                id
                name
                }
                ... on Group {
                id
                name
                }
            }
            bookTemplate {
                id
                name
            }
            studentsClass {
                id
                name
            }
        }
    }
}
`;

